/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');
const CellRange = require('../../model/CellRange');

class SetCellsCommand extends RequestCommand {
	constructor(sheet, cellDescriptors) {
		super(sheet);
		this.cells = cellDescriptors;
		this.oldcells = undefined;
		this._selection = [];
		cellDescriptors.forEach((cell) => {
			const res = CellRange.parse(cell.reference, sheet);
			if (res) {
				res.shiftFromSheet();
				this._selection.push(res);
			}
		});
	}

	createRequest(cells) {
		return super.createRequest({ cells });
	}
	getExecuteRequest() {
		return this.createRequest(this.cells);
	}
	getRedoRequest() {
		return this.createRequest(this.cells);
	}
	getUndoRequest() {
		return this.createRequest(this.oldcells);
	}

	handleResult(result) {
		const { oldcells } = result;
		this.oldcells = this.oldcells || oldcells;
	}
}
module.exports = SetCellsCommand;
